import "./ClientContactList.scss";
import { AuthContext } from "../../context/AuthContext";
import { useContext, useEffect } from "react";
import ClientContactCard from "./ClientContactCard";
import DashboardHeader from "../../components/dashboardheader/DashboardHeader";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useCallback, useState } from "react";
import { SearchIcon } from "../../lib/myIcons";
import SearchList from "../../components/searchlist/SearchList";
import { use } from "react";
import usePaginatedList from "../../components/paginationlist/usePaginationList";
import ContentLoader from "../../components/spinner/ContentLoader";
import OverlayLoader from "../../components/spinner/OverlayLoader";
import CancelButton from "../../components/buttons/cancelbutton/CancelButton";
import encryptedapiRequest from "../../lib/encryptedapiRequest";
import { parseArrayField } from "../../lib/allPurposeFunctions";
import { consumePendingContact } from "../../lib/contactReturnStore";


const ClientContactList = () => {
  const { toggleMenu } = useOutletContext();
  const { currentUser } = useContext(AuthContext);
  const defaultFilters = {
    clientid:currentUser?.clientid,
};


  const storageKey = "clientContactListPage"; // unique key for this page
  const pageLimit=10;

  const navigate=useNavigate();
// console.log("currentuser in client contact list",currentUser);

  const {
    items: clientContacts,
    setItems,
    loading,
    reloading,
    refresh,
  } = usePaginatedList("/clients/contacts/", {
    limit: pageLimit,
    initialFilters: defaultFilters,
    scrollContainerSelector: ".dataContainer", // use your existing scrollable container
    storageKey: storageKey,
    skipInitialFetch: false, // skip fetch if restoring posts

  });



function restoreDraft() {


    const draft = consumePendingContact();
    const returnedContact=draft?.returnData;



  if (!draft) return false;

  console.log("draft ", draft);

  // const returnedPost=draft.returnData;


  switch (draft.action) {

    case 'update':
      console.log("now updating");

      setItems(prevContacts =>
        prevContacts.map(contact => {
          // console.log("Checking contact:", contact.id, "against draft:", returnedContact.id);
          if (String(contact.id) === String(returnedContact.id)) {
            // console.log("Updating Contact:", contact, "with draft:", returnedContact);
            return { ...contact, ...returnedContact };
          }
          return contact;
        })
      );
      break;

    case 'add':
      // console.log("now adding");

      setItems(prevContact => [returnedContact, ...prevContact]);

      break;

    case 'delete':
      // console.log("now deleting");

      setItems(prevContacts =>
        prevContacts.filter(p => p.id !== returnedContact.id)
      );

      break;
  }

  // console.log("restored draft", draft);

  return true;
}


useEffect(() => {
  // to restore if coming back from savepost
  restoreDraft();
}, []);





  // const [searchTerm, setSearchTerm] = useState("");       // current input value
  // const [displayData, setDisplayData] = useState([]); // data to render
  // const [lastServerSearch, setLastServerSearch] = useState("");   // last term fetched from server
  // const [isServerResult, setIsServerResult] = useState(false);




const normalizeContact = (item) => ({
  ...item,
  contacttypes: parseArrayField(item.contacttypes),
  contactnumbers: parseArrayField(item.contactnumbers),
  contactcolonies: parseArrayField(item.contactcolonies),
  contactemails: parseArrayField(item.contactemails),
});



// const handleNoResults = async (term) => {
//   // Skip if we already fetched server data for this term
//   // console.log("data not found locally");

//   if (term === lastServerSearch) return;

//   setLastServerSearch(term);

//   try {
//     // const response = await fetch(`/clients/contacts/?search=${term}`);
//          const response = await encryptedapiRequest.get(`/clients/contacts`, {
//             params: { clientid: currentUser?.clientid, fullsearch: term },
//           });
//         // console.log("server data response:", response.data.data);
//         // response.data already has the array of contacts

//     const rawData = response.data?.data || [];
//     // const normmalizeddata=rawData.map(normalizeContact);
//     // 🔴 THIS WAS MISSING
//     // const normalizedData = rawData.map(normalizeContact);

//     // console.log("normalized data:", normmalizeddata);
    
//     setIsServerResult(true);
//     setDisplayData(rawData);



//   } catch (err) {
//     console.error(err);
//     setDisplayData([]); // show empty if server fails
//   }
// };

// useEffect(() => {
//   if (!searchTerm ) {
//     setIsServerResult(false);
//     setDisplayData(clientContacts || []);
//     setLastServerSearch("");
    
//   }
// }, [clientContacts, searchTerm, isServerResult]);

// useEffect(() => {
//   if (!searchTerm ) {
//     console.log("clientContacts: ", clientContacts);
//     setIsServerResult(false);
//     setDisplayData(clientContacts); // revert to paginated data
//     // setLastServerSearch("");
//   }
// }, [searchTerm, clientContacts]);



  // const clientContacts = [
  //   {
  //     id: 1,
  //     ClientContactName: "Rahul Sharma",
  //     ClientContactTypes: "Buyer,Financier",
  //     ClientContactColonyInterests: ["Green Park", "Hauz Khas"],
  //     ClientContactNumbers: ["9876543210", "9123456789"],
  //   },
  //   {
  //     id: 2,
  //     ClientContactName: "Anita Verma",
  //     ClientContactTypes: "Tenant",
  //     ClientContactColonyInterests: ["Malviya Nagar"],
  //     ClientContactNumbers: ["9988776655"],
  //   },
  //   {
  //     id: 3,
  //     ClientContactName: "Amit Khanna",
  //     ClientContactTypes: "Investor",
  //     ClientContactColonyInterests: ["Saket", "Chattarpur"],
  //     ClientContactNumbers: ["9000011111", "9000022222"],
  //   },
  // ];


  // const [filteredContacts, setFilteredContacts] = useState(clientContacts);
  

// const arraysEqual = (a, b) => {
//   if (a === b) return true;
//   if (!a || !b || a.length !== b.length) return false;
//   for (let i = 0; i < a.length; i++) {
//     if (a[i].id !== b[i].id) return false; // compare unique id
//   }
//   return true;
// };



  const handleNewContact = async (e) => {
     e.preventDefault();
    //  alert("ss")
     try {
      navigate('/dashboard/savecontact/', {state:{mode:0,clientcontact:null, clientcontactid:0,clientid:currentUser?.clientid }});
      
     } catch (error) { 
     }
     
  }


  return (
    <div className="clientContactListPage">
      <div className="PageHeader">
        {/* {console.log("Client Contacts ALL: ", clientContacts)} */}
        <DashboardHeader title="Contacts" toggleMenu={toggleMenu} />
      </div>

      {/* 🔍 Search Bar */}
      <div className="ClientContactSearch">
        {/* <div className="SearchInputWrapper">
          <span className="SearchIcon">
              <SearchIcon size={24} />
          </span>

          <input
            type="text"
            placeholder="Search by name, type, colony or number..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div> */}
      </div>

      <div className="ClientContactListContainer">
        {/* {filteredContacts.length > 0 ? (
          filteredContacts.map((client) => (
            <ClientContactCard key={client.id} client={client} />
          ))
        ) : (
          <p className="NoResults">No matching contacts found</p>
        )} */}

        {/* <SearchList
            data={clientContacts}
            dataFields={["ClientContactName", "ClientContactTypes", "ClientContactColonyInterests", "ClientContactNumbers"]}
            placeholder="Search by name, type, colony or number..."
            
            renderItem={(client) => <ClientContactCard key={client.id} client={client} />}


        ></SearchList> */}

        {/* <SearchList
            data={clientContacts}
            dataFields={["contactname", "contacttypes", "contactcolonies", "contactnumbers"]}
            placeholder="Search by name, type, colony or number..."
            
            renderItem={(client) => <ClientContactCard key={client.id} client={client} />}


        ></SearchList> */}

        <SearchList
          // value={searchTerm}
          // onChange={setSearchTerm}
          // onNoResults={handleNoResults}
          // onNoResults={(term) => {
          //     if (!isServerResult) handleNoResults(term);
          //   }}

          // onFilteredData={setDisplayData}  // 🔹 update displayed data immediately
          // onFilteredData={(data) => {
          //     if (!isServerResult) {
          //       setDisplayData(data);
          //     }
          //   }}

          // onFilteredData={(data) => {
          //   if (!isServerResult && !arraysEqual(displayData, data)) {
          //     setDisplayData(data);
          //   }
          // }}

          // onFilteredData={(data) => {
          //     if (!isServerResult) setDisplayData(data);
          //   }}

          data={clientContacts}
          //  data={displayData.length ? displayData : clientContacts}
          // data={isServerResult ? displayData : clientContacts}
          dataFields={[
            "contactname",
            "contacttypes",
            "contactcolonies",
            "contactnumbers",
            "contactemails",
          ]}
          serverConfig={{
            url: "/clients/contacts",
            params: { clientid: currentUser?.clientid },
            limit:3,
          }}
          renderItem={(client, idx, handleClick) => (
            <ClientContactCard
              key={client.id}
              clientcontact={client}
              clientid={currentUser?.clientid}
              onClick={handleClick}
            />
          )}
          onSelect={(client) =>
            navigate("/dashboard/savecontact/", {
              state: { mode: 1, clientid: currentUser?.clientid, clientcontact: client ,clientcontactid:client.id},
            })
          }

          // renderItem={(client) => (
          //   <ClientContactCard key={client.id} clientcontact={client}  clientid={currentUser?.clientid} />
          // )}
        />

      
        <div className="dataContainer">

          {loading ? (
            <ContentLoader />
          ) : clientContacts.length > 0 ? (
            clientContacts.map((client) => (
              // console.log("client: ", client),
              <ClientContactCard
                key={client.id}
                clientcontact={client}
                clientid={currentUser?.clientid}
              />
            ))
          ) : (
            <p className="NoResults">No matching contacts found</p>
          )}

        </div>


        {reloading && (
          <OverlayLoader
            position="sticky"
            bottom={0}
            text="Loading more..."
            background="rgba(200, 200, 200, 0.7)"
            height="150px"
          />
        )}





      </div>

      <div className="buttonContainer">
        <button className="AddContactButton" onClick={handleNewContact}>
          Add Contact
        </button>
        <CancelButton></CancelButton>
      </div>
    </div>
  );
};

export default ClientContactList;
